import * as yup from 'yup';
import { FIELDS } from 'modules/cm/fields/types';

export default yup.object().shape({
  [FIELDS.RATIONALE]: yup.string(),
});
